import Helmet from "react-helmet";

import { useTranslation } from "@mywheels/common/lib/translation";

import { useScrollToTop } from "web/ui";
import { ToolbarSpacer } from "web/layout/Toolbar";

export default function PressPage() {
  const { t } = useTranslation();

  useScrollToTop();

  const title = t("Pers");

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>

      <ToolbarSpacer />

      <div className="container mt-6 md:mt-10">
        <h1 className="text-center text-3xl md:text-4xl">{title}</h1>

        <div className="mt-8 md:mt-10 mx-auto max-w-[720px] text-gray600 prose">
          <div className="mb-8">
            <img
              alt=""
              src="https://media.graphcms.com/output=format:jpg/vj4IKeLHQCSnbyPMVONH"
            />
          </div>
          <p>
            Voor het laatste nieuws en de media kit klik hier:{" "}
            <a
              target="_blank"
              rel="noreferrer"
              href="https://press.thesharinggroup.com/tags/mywheels/"
            >
              Persomgeving
            </a>
            .
          </p>
          <p>
            Voor persvragen, interviews of extra beeldmateriaal kun je contact
            opnemen per e-mail via{" "}
            <a href="mailto:pers@mywheels.nl">pers@mywheels.nl</a>.
          </p>
        </div>
      </div>
    </>
  );
}
